import { useEffect } from 'react';
import * as yup from 'yup';
import useToast from './toast.hook';
import useTranslation from 'next-translate/useTranslation';
import { useToastStore } from '@/stores/useToastStore';

function useValidator(errors: object | undefined) {
	/* const { openToast } = useToast() */
	const openToast = useToastStore((state) => state.openToast);

	const { t } = useTranslation();

	// Set message
	yup.setLocale({
		// use constant translation keys for messages without values
		string: {
			email: ({ path }) => t('validations:invalid', { field: t(`fields:${path}`) }),
			min: ({ min, path }) => t('validations:min_length', { field: t(`fields:${path}`), value: min }),
			max: ({ max, path }) => t('validations:max_length', { field: t(`fields:${path}`), value: max }),
			length: ({ length, path }) => t('validations:exact_length', { field: t(`fields:${path}`), value: length }),
		},
		mixed: {
			required: ({ path }) => t('validations:required', { field: t(`fields:${path}`) }),
		},
		number: {
			min: ({ min, path }) => t('validations:min_val', { field: t(`fields:${path}`), value: min }),
			moreThan: ({ more, path }) => t('validations:more_val', { field: t(`fields:${path}`), value: more }),
			max: ({ max, path }) => t('validations:max_val', { field: t(`fields:${path}`), value: max }),
		},
		array: {
			min: ({ min, path }) => t('validations:min_array', { field: t(`fields:${path}`), value: min }),
		},
	});

	/**
	 * Errors Form
	 */
	useEffect(() => {
		if (errors && Object.keys(errors).length) {
			if (Object.keys(errors).length) {
				const fields = Object.values(errors).map((er) => {
					if (Array.isArray(er)) {
						return t('validation:list_data');
					}
					return er?.message ?? er?.root?.message;
				});

				openToast({ text: t('validations:validation_error'), fields: fields, status: 'danger' });
			}
		}
	}, [errors]);

	return {};
}

export default useValidator;
